"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertStatusStage = void 0;
var AlertStatusStage;
(function (AlertStatusStage) {
    AlertStatusStage["NEW"] = "New";
    AlertStatusStage["IN_PROGRESS"] = "InProgress";
    AlertStatusStage["IMPORTED"] = "Imported";
    AlertStatusStage["CLOSED"] = "Closed";
})(AlertStatusStage = exports.AlertStatusStage || (exports.AlertStatusStage = {}));
